import React, {useEffect, useState} from 'react'
import {Accordion, Button, Col, Form, Modal, Row, Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import i18next from 'i18next'
import {PopoverText, RichText} from 'src/components'
import {MultiSelect} from 'react-multi-select-component'
import {getRoleFlagList} from 'src/api/modules/master-data/master_2'
import {KTSVG} from 'src/_metronic/helpers'
import swal from 'sweetalert'
import CurrencyInput from 'react-currency-input-field'

interface PropsItem {
  item: any
  show: boolean
  title: string
  onCloseModal(): void
  onStoreSchedule(schedules: any[], index: number): void
}

export const ScheduleModal: React.FC<PropsItem> = (props) => {
  const {t} = useTranslation()

  const [day, setDay] = useState<any>(0)
  const [month, setMonth] = useState<any>(0)
  const [year, setYear] = useState<any>(0)
  const [dateNow, setDateNow] = useState('')
  
  const [tempTanggal, setTempTanggal] = useState(0)
  const [daysInMonth, setDaysInMonth] = useState(0)
  const [tempMinggu, setTempMinggu] = useState(0)
  const [tempBulan, setTempBulan] = useState(0)
  const [tempTahun, setTempTahun] = useState(0)
  const [tempTon, setTempTon] = useState(0)
  const [listYear, setListYear] = useState<any[]>([])

  const [schedules, setSchedules] = useState<any[]>([])

  useEffect(() => {
    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    setDay(today.getDate())
    setMonth(today.getMonth() + 1)
    setYear(today.getFullYear())
    setDateNow(dd + '-' + mm + '-' + yyyy)
    setDaysInMonth(getDaysInMonth(today.getFullYear(), today.getMonth() + 1))

    const handleYear = () => {
      let year = []
      const aYearFromNow = new Date()
      year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear())).getFullYear())
      for (let i = 0; i < 2; i++) {
        year.push(new Date(aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1)).getFullYear())
      }
      setListYear(year)
    }

    handleYear()
    setSchedules(props.item?.schedules || [])
  }, [props.show])

  useEffect(() => {
    if (tempTahun != 0 && tempBulan != 0) setDaysInMonth(getDaysInMonth(tempTahun, tempBulan))
  }, [tempTahun, tempBulan])

  function getDaysInMonth(year: any, month: any) {
    return new Date(year, month, 0).getDate()
  }

  const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]

  function loopTanggal(jumlah: any) {
    var indents = []
    for (let i = 0; i < jumlah; i++) {
      indents.push(<option value={i + 1}>{i + 1}</option>)
    }
    return indents
  }

  const validasiJadwal = () => {
    if (tempTanggal == 0) return t('Tanggal ke-')
    else if (tempBulan == 0) return t('Bulan ke-')
    else if (tempTahun == 0) return t('Tahun ke-')
    else if (tempTon == 0) return t('Tonnage')
    else return 'nothing'
  }

  const checktaking = () => {
    let temp: any[] = schedules
    let tempindex = 0

    if (temp == null) tempindex = 0
    else tempindex = temp.length

    if (tempTahun > year + 1) return 'Tahun tidak boleh melebihi tahun ini'

    if (tempTanggal > getDaysInMonth(tempTahun, tempBulan)) return 'Tanggal melebihi'

    if (tempindex != 0) {
      if (temp[tempindex - 1].year <= tempTahun) {
        if (temp[tempindex - 1].year < tempTahun) {
          if (tempTahun == year) {
            if (tempBulan == month) {
              if (tempTanggal >= day) return 'nothing'
              else return 'Week must be greater than or equal to current week'
            } else if (tempBulan > month) return 'nothing'
            else return 'Month must be greater than or equal to current month'
          } else if (tempTahun > year) return 'nothing'
          else return 'Year must be greater than or equal to current year'
        } else if (temp[tempindex - 1].month <= tempBulan) {
          if (temp[tempindex - 1].month < tempBulan) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else if (temp[tempindex - 1].date < tempTanggal) {
            if (tempTahun == year) {
              if (tempBulan == month) {
                if (tempTanggal >= day || day > 28) return 'nothing'
                else return 'Week must be greater than or equal to current week'
              } else if (tempBulan > month) return 'nothing'
              else return 'Month must be greater than or equal to current month'
            } else if (tempTahun > year) return 'nothing'
            else return 'Year must be greater than or equal to current year'
          } else return 'Week must be greater than previous week'
        } else return 'Month must be greater than previous month'
      } else return 'Year must be greater than previous year'
    } else {
      if (tempTahun == year) {
        if (tempBulan == month) {
          if (tempTanggal >= day || day > 28) return 'nothing'
          else return 'Week must be greater than or equal to current week'
        } else if (tempBulan > month) return 'nothing'
        else return 'Month must be greater than or equal to current month'
      } else if (tempTahun > year) return 'nothing'
      else return 'Year must be greater than or equal to current year'
    }
  }

  const clearInputJadwal = () => {
    const input1 = document.getElementById('jadwalminggu') as HTMLInputElement
    input1.value = ''
    const input2 = document.getElementById('jadwalbulan') as HTMLSelectElement
    input2.selectedIndex = 0
    const input3 = document.getElementById('jadwaltahun') as HTMLSelectElement
    input3.selectedIndex = 0
    const input4 = document.getElementById('jadwalton') as HTMLInputElement
    input4.value = ''
    const input5 = document.getElementById('jadwaltanggal') as HTMLSelectElement
    input5.selectedIndex = 0
  }

  const clearStateJadwal = () => {
    setTempTanggal(0)
    setTempBulan(0)
    setTempTahun(0)
    setTempTon(0)
  }

  const sendJadwal = () => {
    const totalQuantum = schedules.reduce((acc, schedule) => {
      return acc + schedule.tonnage
    }, tempTon)

    const checkMandatory = validasiJadwal()
    const CheckTaking = checktaking()

    if (CheckTaking == 'nothing') {
      if (checkMandatory == 'nothing') {
        if (props.item?.quantum >= totalQuantum) {
          const new_schedules = [... schedules,  {
            sort: schedules?.length + 1,
            date: tempTanggal,
            month: tempBulan,
            year: tempTahun,
            tonnage: tempTon,
          }]
          setSchedules(new_schedules)
          props.onStoreSchedule(new_schedules, props.item?.index)
          clearInputJadwal()
          clearStateJadwal()
        } else {
          swal({
            title: t('Melebihi Tonase!'),
            icon: 'error',
          })
        }
      } else {
        swal({
          title: t('isi') + checkMandatory,
          icon: 'error',
        })
      }
    } else {
      swal({
        title: t(CheckTaking),
        icon: 'error',
      })
    }
  }

  const deleteSchedule = (_index: number) => {
    swal({
      title: `${t('Are you sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {

        const new_schedules = schedules
          .filter((item: any, idx) => idx != _index)
          .map((item: any, idx2) => ({... item, sort: (idx2 + 1)}))

        setSchedules(new_schedules)
        props.onStoreSchedule(new_schedules, props.item?.index)

        swal({
          closeOnClickOutside: false,
          title: t('Dokumen Berhasil Dihapus'),
          icon: 'success',
        })

      }
    })
  }

  return (
    <div>
      <Modal
          show={props.show}
          onHide={() => {
            props.onCloseModal()
            clearInputJadwal()
            clearStateJadwal()
          }}
          centered
          size='xl'
          backdrop='static'
          keyboard={false}
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>
                {props.title}
            </Modal.Title>
          </Modal.Header>
          
          <Modal.Body>
            <>
            <div className='table-responsive bdr mt-1'>
                <table className='table-border w-100'>
                  <thead>
                    <tr className='d-flex'>
                      {/* <th style={{ width: '60px' }} className="text-center">{t('order-aksi')}</th> */}
                      <th style={{width: '165.5px'}} className='text-center'>
                        {t('order-pengambilan')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-tanggal')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-minggu')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-bulan')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {t('order-tahun')}
                      </th>
                      <th style={{width: '185.5px'}} className='text-center'>
                        {props.item?.product_type != '8105' ? t('order-tonase') : t('sack')}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <div>
                      <tr className='d-flex'>
                        <td style={{width: '165.5px'}} className='text-center'>
                          <p className='mt-3'>{(schedules.length || 0) + 1}</p>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <Form.Select
                            aria-label='Default select example'
                            id='jadwaltanggal'
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            onChange={(e: any) => setTempTanggal(parseInt(e.target.value))}
                          >
                            <option selected value={0} disabled hidden>
                              {t('Pilih-Tanggal')}
                            </option>
                            {daysInMonth != 0 ? loopTanggal(daysInMonth) : ''}
                          </Form.Select>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <Form.Control
                            aria-label='Default select example'
                            id='jadwalminggu'
                            placeholder={t('order-minggu')}
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            value={
                              tempTanggal == 0 ? '' : t('Week') + Math.ceil(tempTanggal / 7)
                            }
                          />
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <Form.Select
                            aria-label='Default select example'
                            id='jadwalbulan'
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            onChange={(e: any) => setTempBulan(parseInt(e.target.value))}
                          >
                            <option selected disabled>
                              {t('Pilih-Month')}
                            </option>
                            <option value='1'>{t('Januari')}</option>
                            <option value='2'>{t('Februari')}</option>
                            <option value='3'>{t('Maret')}</option>
                            <option value='4'>{t('April')}</option>
                            <option value='5'>{t('Mei')}</option>
                            <option value='6'>{t('Juni')}</option>
                            <option value='7'>{t('Juli')}</option>
                            <option value='8'>{t('Agustus')}</option>
                            <option value='9'>{t('September')}</option>
                            <option value='10'>{t('Oktober')}</option>
                            <option value='11'>{t('November')}</option>
                            <option value='12'>{t('Desember')}</option>
                          </Form.Select>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <Form.Select
                            aria-label='Default select example'
                            style={{padding: '0.775rem 3rem 0.4rem 1rem', width: '90%'}}
                            id='jadwaltahun'
                            onChange={(e: any) => setTempTahun(parseInt(e.target.value))}
                          >
                            <option selected disabled>
                              {t('Pilih-Year')}
                            </option>
                            {listYear.map((data: string, index: number) => {
                              return (
                                <option key={data ?? index} value={data}>
                                  {data}
                                </option>
                              )
                            })}
                          </Form.Select>
                        </td>
                        <td
                          style={{width: '185.5px'}}
                          className='text-center d-flex justify-content-center'
                        >
                          <CurrencyInput
                            id='jadwalton'
                            className='form-control form-control-sm'
                            placeholder={props.item?.product_type != '8105' ? t('order-tonase') : t('sack')}
                            key={tempTahun}
                            style={{width: '90%'}}
                            decimalSeparator={i18next.language === 'en' ? '.' : ','}
                            groupSeparator={i18next.language === 'en' ? ',' : '.'}
                            onValueChange={(value: any) => {
                              setTempTon(parseFloat(value?.replace(/,/g, '.')))
                            }}
                            decimalsLimit={3}
                          />
                        </td>
                      </tr>
                    </div>
                  </tbody>
                  <div className='d-flex justify-content-end mt-5'>
                    <Button
                      variant='primary'
                      onClick={sendJadwal}
                    >
                      {t('order-kirim')}
                    </Button>
                  </div>
                </table>
              </div>
              <span style={{fontSize: '15px'}} className='fw-bold d-block'>
                {t('Jadwal')}
              </span>
              {schedules?.length < 1 ? (
                <div className='text-center fs-4 fw-semibold'>{t('no schedule')}</div>
              ) : (
                <div className='table-responsive bdr mt-2'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead className='border-bottom'>
                      <tr className='fw-bold '>
                        <th className='text-center'>{t('order-pengambilan')}</th>
                        <th className='text-center'>{t('order-tanggal')}</th>
                        <th className='text-center'>{t('order-minggu')}</th>
                        <th className='text-center'>{t('order-bulan')}</th>
                        <th className='text-center'>{t('order-tahun')}</th>
                        <th className='text-center'>{t('order-tonase')}</th>
                        <th className='text-center'>{t('order-aksi')}</th>
                      </tr>
                    </thead>
                    {schedules?.map((data: any, _index: number) => (
                      <tbody key={data?.id ?? _index}>
                        <tr className=''>
                          <td className='text-center'>
                            <label>{_index + 1}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.date}</label>
                          </td>
                          <td className='text-center'>
                            <label>
                              {t('Week')} {Math.ceil(data.date / 7)}
                            </label>
                          </td>
                          <td className='text-center'>
                            <label>{t(bulan[data.month - 1])}</label>
                          </td>
                          <td className='text-center'>
                            <label>{data.year}</label>
                          </td>
                          <td className='text-center'>
                            <label>
                              {(i18next.language === 'en'
                                ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                                : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})) +
                                ' ' +
                                'Ton'}
                            </label>
                          </td>
                          <td className='text-center'>
                            <button
                                onClick={() => {
                                  deleteSchedule(_index)
                                }}
                                className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/trash-fill.svg'
                                  className='svg-icon-3'
                                />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              )}
            </>
          </Modal.Body>
        </Modal>
    </div>
  )
}
